var backgrounds = [
    {
        backgroundId: 0,
        position: 0,
        isPremium: false,
        darkThumbUrl: 'https://t00.deviantart.net/sI8a_kmeoXxczZeq4yZnpHv38LM=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/a3a9/th/pre/i/2018/271/2/d/00___dark_by_yumeruby-dcnzmyd.jpg',
        darkSmallUrl: 'https://img00.deviantart.net/14ed/i/2018/271/2/d/00___dark_by_yumeruby-dcnzmyd.jpg?small',
        darkBigUrl: 'https://img00.deviantart.net/14ed/i/2018/271/2/d/00___dark_by_yumeruby-dcnzmyd.jpg?big',
        lightThumbUrl: 'https://t00.deviantart.net/KLrpAageZs8AIOobgcdlhHDUOdM=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/33ab/th/pre/i/2018/271/1/0/00___bright_by_yumeruby-dcnzmym.jpg',
        lightSmallUrl: 'https://img00.deviantart.net/f703/i/2018/271/1/0/00___bright_by_yumeruby-dcnzmym.jpg?small',
        lightBigUrl: 'https://img00.deviantart.net/f703/i/2018/271/1/0/00___bright_by_yumeruby-dcnzmym.jpg?big',
    },
    {
        backgroundId: 1,
        position: 1,
        isPremium: false,
        darkThumbUrl: 'https://t00.deviantart.net/MFVYvUZ1RytE1fR2k8qfQ5xM7EY=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/3445/th/pre/i/2018/271/d/7/01___dark_by_yumeruby-dcnzmy1.png',
        darkSmallUrl: 'https://img00.deviantart.net/066d/i/2018/271/d/7/01___dark_by_yumeruby-dcnzmy1.png?small',
        darkBigUrl: 'https://img00.deviantart.net/066d/i/2018/271/d/7/01___dark_by_yumeruby-dcnzmy1.png?big',
        lightThumbUrl: 'https://t00.deviantart.net/D9Wrr9XHcFLpTah7RqjiKk0xZqk=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/c33c/th/pre/i/2018/271/f/f/01___bright_by_yumeruby-dcnzmy8.jpg',
        lightSmallUrl: 'https://img00.deviantart.net/1242/i/2018/271/f/f/01___bright_by_yumeruby-dcnzmy8.jpg?small',
        lightBigUrl: 'https://img00.deviantart.net/1242/i/2018/271/f/f/01___bright_by_yumeruby-dcnzmy8.jpg?big',
    },
    {
        backgroundId: 2,
        position: 2,
        isPremium: false,
        darkThumbUrl: 'https://t00.deviantart.net/q2BTxxlKV76xSKP-eRf3yAztCSc=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/51d7/th/pre/i/2018/271/8/c/02___dark_by_yumeruby-dcnzmxj.png',
        darkSmallUrl: 'https://img00.deviantart.net/a17d/i/2018/271/8/c/02___dark_by_yumeruby-dcnzmxj.png?small',
        darkBigUrl: 'https://img00.deviantart.net/a17d/i/2018/271/8/c/02___dark_by_yumeruby-dcnzmxj.png?big',
        lightThumbUrl: 'https://t00.deviantart.net/c3qZHlDWb4j9UFaYUMCIyvW6CCg=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/20f0/th/pre/i/2018/271/e/9/02___bright_by_yumeruby-dcnzmxu.jpg',
        lightSmallUrl: 'https://img00.deviantart.net/3079/i/2018/271/e/9/02___bright_by_yumeruby-dcnzmxu.jpg?small',
        lightBigUrl: 'https://img00.deviantart.net/3079/i/2018/271/e/9/02___bright_by_yumeruby-dcnzmxu.jpg?big',
    },
    {
        backgroundId: 3,
        position: 3,
        isPremium: false,
        darkThumbUrl: 'https://t00.deviantart.net/c5TrMNPgrK3qE5IdglMmlyw94Jo=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/0909/th/pre/i/2018/271/1/0/03___dark_by_yumeruby-dcnzmx2.png',
        darkSmallUrl: 'https://img00.deviantart.net/3498/i/2018/271/1/0/03___dark_by_yumeruby-dcnzmx2.png?small',
        darkBigUrl: 'https://img00.deviantart.net/3498/i/2018/271/1/0/03___dark_by_yumeruby-dcnzmx2.png?big',
        lightThumbUrl: 'https://t00.deviantart.net/YJdiONe4IV5vUXJUE4IH_AqwnA8=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/3963/th/pre/i/2018/271/c/f/03___bright_by_yumeruby-dcnzmxb.jpg',
        lightSmallUrl: 'https://img00.deviantart.net/e18c/i/2018/271/c/f/03___bright_by_yumeruby-dcnzmxb.jpg?small',
        lightBigUrl: 'https://img00.deviantart.net/e18c/i/2018/271/c/f/03___bright_by_yumeruby-dcnzmxb.jpg?big',
    },
    {
        backgroundId: 4,
        position: 4,
        isPremium: true,
        darkThumbUrl: 'https://t00.deviantart.net/oR3u1Le_n7rNW8mHvn5TaaaYZiE=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/8f40/th/pre/i/2018/271/e/9/04___dark_by_yumeruby-dcnzmwk.jpg',
        darkSmallUrl: 'https://img00.deviantart.net/83eb/i/2018/271/e/9/04___dark_by_yumeruby-dcnzmwk.jpg?small',
        darkBigUrl: 'https://img00.deviantart.net/83eb/i/2018/271/e/9/04___dark_by_yumeruby-dcnzmwk.jpg?big',
        lightThumbUrl: 'https://t00.deviantart.net/ykr0UJCDSsBWMVpfS4tqM2tmEbc=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/585c/th/pre/i/2018/271/1/a/04___bright_by_yumeruby-dcnzmww.jpg',
        lightSmallUrl: 'https://img00.deviantart.net/3356/i/2018/271/1/a/04___bright_by_yumeruby-dcnzmww.jpg?small',
        lightBigUrl: 'https://img00.deviantart.net/3356/i/2018/271/1/a/04___bright_by_yumeruby-dcnzmww.jpg?big',
    },
    {
        backgroundId: 5,
        position: 5,
        isPremium: true,
        darkThumbUrl: 'https://t00.deviantart.net/TX5Crkc-UIF5SjzVRa-kWIXUIR4=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/d808/th/pre/i/2018/271/c/0/05___dark_by_yumeruby-dcnzmw4.jpg',
        darkSmallUrl: 'https://img00.deviantart.net/2141/i/2018/271/c/0/05___dark_by_yumeruby-dcnzmw4.jpg?small',
        darkBigUrl: 'https://img00.deviantart.net/2141/i/2018/271/c/0/05___dark_by_yumeruby-dcnzmw4.jpg?big',
        lightThumbUrl: 'https://t00.deviantart.net/LXRzmd2fhSwAvYg_EH6yZBvpk6w=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/9b8c/th/pre/i/2018/271/4/8/05___bright_by_yumeruby-dcnzmwb.jpg',
        lightSmallUrl: 'https://img00.deviantart.net/f4df/i/2018/271/4/8/05___bright_by_yumeruby-dcnzmwb.jpg?small',
        lightBigUrl: 'https://img00.deviantart.net/f4df/i/2018/271/4/8/05___bright_by_yumeruby-dcnzmwb.jpg?big',
    },
    {
        backgroundId: 6,
        position: 6,
        isPremium: true,
        darkThumbUrl: 'https://t00.deviantart.net/vTq5qDf6oYOxO4K2oVEems_mYrY=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/d632/th/pre/i/2018/271/c/8/06___dark_by_yumeruby-dcnzmvk.jpg',
        darkSmallUrl: 'https://img00.deviantart.net/2c9b/i/2018/271/c/8/06___dark_by_yumeruby-dcnzmvk.jpg?small',
        darkBigUrl: 'https://img00.deviantart.net/2c9b/i/2018/271/c/8/06___dark_by_yumeruby-dcnzmvk.jpg?big',
        lightThumbUrl: 'https://t00.deviantart.net/314WFN0OZoARWAsRPqkNrkPNlPM=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/c1de/th/pre/i/2018/271/0/2/06___bright_by_yumeruby-dcnzmvt.jpg',
        lightSmallUrl: 'https://img00.deviantart.net/8ac3/i/2018/271/0/2/06___bright_by_yumeruby-dcnzmvt.jpg?small',
        lightBigUrl: 'https://img00.deviantart.net/8ac3/i/2018/271/0/2/06___bright_by_yumeruby-dcnzmvt.jpg?big',
    },
    {
        backgroundId: 7,
        position: 7,
        isPremium: true,
        darkThumbUrl: 'https://t00.deviantart.net/CVaRnhcILKED_wd9fjS_igQnJiw=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/d9a5/th/pre/i/2018/271/b/4/07___dark_by_yumeruby-dcnzmuy.jpg',
        darkSmallUrl: 'https://img00.deviantart.net/56cb/i/2018/271/b/4/07___dark_by_yumeruby-dcnzmuy.jpg?small',
        darkBigUrl: 'https://img00.deviantart.net/56cb/i/2018/271/b/4/07___dark_by_yumeruby-dcnzmuy.jpg?big',
        lightThumbUrl: 'https://t00.deviantart.net/YqyVpNvUqus4bljUdy6cRGj5lK0=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/9617/th/pre/i/2018/271/4/2/07___bright_by_yumeruby-dcnzmvb.jpg',
        lightSmallUrl: 'https://img00.deviantart.net/6319/i/2018/271/4/2/07___bright_by_yumeruby-dcnzmvb.jpg?small',
        lightBigUrl: 'https://img00.deviantart.net/6319/i/2018/271/4/2/07___bright_by_yumeruby-dcnzmvb.jpg?big',
    },
    {
        backgroundId: 8,
        position: 8,
        isPremium: true,
        darkThumbUrl: 'https://t00.deviantart.net/zBunBs00zRZ6BGpE_2eJT1Eb49s=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/e4fd/th/pre/i/2018/271/d/c/08___dark_by_yumeruby-dcnzmuk.png',
        darkSmallUrl: 'https://img00.deviantart.net/0b43/i/2018/271/d/c/08___dark_by_yumeruby-dcnzmuk.png?small',
        darkBigUrl: 'https://img00.deviantart.net/0b43/i/2018/271/d/c/08___dark_by_yumeruby-dcnzmuk.png?big',
        lightThumbUrl: 'https://t00.deviantart.net/iLTz5OTUMGBeF9Lqg6FO04PzFTA=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/6caa/th/pre/i/2018/271/a/d/08___bright_by_yumeruby-dcnzmuq.jpg',
        lightSmallUrl: 'https://img00.deviantart.net/af12/i/2018/271/a/d/08___bright_by_yumeruby-dcnzmuq.jpg?small',
        lightBigUrl: 'https://img00.deviantart.net/af12/i/2018/271/a/d/08___bright_by_yumeruby-dcnzmuq.jpg?big',
    },
];
export function getBackgrounds(offset, limit) {
    if (offset === void 0) { offset = 0; }
    if (limit === void 0) { limit = 10; }
    return backgrounds.slice(offset, Number(offset) + Number(limit));
}
export function randomBackground() {
    var offset = Math.round(Math.random() * backgrounds.length);
    return backgrounds[offset];
}
//# sourceMappingURL=_fixtures.js.map